import { IExtendedImageOptions, IImageOptions } from '@/core/responsive/image/image.types';

function convertParamsToStr(options: Partial<IExtendedImageOptions>): string {
    return Object.keys(options).map((key: string) => {
        const value = options[(key as keyof IImageOptions)];
        return value ? `${key}=${encodeURIComponent(value)}` : null;
    }).filter((value) => value !== null).join(',');
}

export default convertParamsToStr;
